module.exports = __webpack_public_path__ + "img/901540801.c91b1125.png";